module.exports = __webpack_public_path__ + "static/img/19.584650a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/19.png
// module id = u2sC
// module chunks = 35